export default {
  // login
  'intro': {
    'page': {
      'title': 'Login and registration for businesses',
      'description': 'Log in to Booksy Biz or create an account to easily manage bookings and your business!',
    },
    'title': 'Welcome Back!',
    'subtitle': 'Sign in to your Booksy account.',
    'get-started': 'Get Started',
    'app-link': 'Trying to book an appointment? Use Booksy for Customers.',
    'slider': [
      {
        'title': 'You\'ve built a business doing things your way.',
        'content': 'You love it, but managing the day-to-day, keeping clients in the loop, and marketing your skills slows your momentum.',
      },
      {
        'title': 'We\'re your partner, your sidekick, your employee of the month.',
        'content': 'Booksy does more than just appointments. Let us help you streamline all of that extra work so that you can focus on doing what you love. ',
      },
      {
        'title': 'We help you be you, only better.',
        'content': 'You\'ve got the talent. Now we\'ll give you the tools to help you run your business and get you to where you\'re going. Wherever that may be. ',
      },
    ],
  },
  'email': {
    'title': 'What is your email address?',
    'terms-info': 'By signing up I agree to the',
    'terms-conditions': 'Terms & Conditions',
    'terms-info-and': 'and to the',
    'privacy-policy': 'Privacy Policy',
    'field': 'E-mail address',
    'sign-in': 'Sign in',
  },
  'extole-terms': {
    'terms-info': 'By signing up I accept the referral and agree to the <a href="{termsUrl}" target="_blank" class="terms-link b-font-medium">Terms and Conditions</a> of this program',
  },
  'other-methods': {
    'title': 'Other Sign in Methods',
    'email': 'Continue with email',
    'fb': 'Continue with Facebook',
    'ios': 'Continue with Apple',
    'revoke-apple-id-modal': {
      'title': 'How to log into Booksy with your Apple ID?',
      'description': 'In order to log into Booksy, you need to clear the Apple ID login setting for the Booksy app then log into Booksy with your Apple ID again.',
      'step-1': 'Go to Settings on your iPhone/iPad',
      'step-2': 'Tap your name',
      'step-3': 'Tap "Password & Security”',
      'step-4': 'Tap "Apps Using Apple ID"',
      'step-5': 'Find „Booksy Pro” and tap',
      'step-6': 'Tap "Stop Using Apple ID"',
      'step-7': 'Tap "Stop Using"',
      'step-8': 'Open Booksy app then log in with your Apple ID again.',
      'sorry': 'Sorry for the inconvenience. If you still aren\'t able to log in, contact the Support Team.',
    },
  },
  'password': {
    'title': 'Login',
    'subtitle': 'It looks like there\'s already a profile associated with this <br> e-mail address.',
    'password': 'Password',
    'password-rules': {
      'title': 'The password must contain:',
      'letter': 'at least one letter',
      'digit': 'at least one digit',
      'characters': '8 characters or more',
    },
    'show': 'Show',
    'hide': 'Hide',
    'forgot': 'Forgot password?',
    'strenght': {
      'blank': 'Password Strength',
      'weak': 'Weak',
      'medium': 'Medium',
      'strong': 'Strong',
    },
    'is-common': {
      'title': 'Common Password',
      'text': 'You have selected a common password. For security purposes, we suggest you choose a stronger password or add extra characters to the current one.',
      'update-label': 'Update Password',
      'continue-label': 'Continue Despite Security Risk',
    },
  },
  'forgot-password': {
    'title': 'Forgot Password?',
    'subtitle': 'Please enter the e-mail associated with your Booksy account. We\'ll send you a message with a link to reset your password.',
    'button': 'Reset password',
    'success': 'E-mail Sent! A password reset link has been sent to your e-mail address.',
  },
  'invited-only': {
    'title': 'Early Access is by Invite Only',
    'subtitle': 'At this time Early Access to the new Booksy experience is by invite only.',
    'description': 'If you\'re an existing Booksy Provider who would like a sneak peak of what\'s coming, give us a shout: <a href="mailto:booksybusiness@booksy.com">booksybusiness@booksy.com</a>. <br/><br/>For now, continue to use Booksy Biz to manage your business and empower your customers to book themselves.',
    'use-booksy-biz': 'Use Booksy Biz',
  },
  'from-versum': {
    'title': 'Versum and Booksy have teamed up!',
    'desc': 'From January 31, 2022, it’s no longer possible to buy Versum subscription or set up a trial account.  <strong>We hope that you will find what you’re looking for in Booksy Biz!</strong> <br><br> Set up a free trial account in Booksy and try out features such as calendar, reports or marketing tools. Let your clients book with you on <strong>the most popular booking platform in Poland!</strong>',
    'button': 'Start using for free',
  },
  // end login
  // gdpr
  'gdpr': {
    'title': 'Your data protection',
    'subtitle': 'The General Data Protection Regulation (GDPR) puts you in charge of your personal data. Please select how your data can be used.',
    'agree-to-all': 'Agree to all of the following',
  },
  // end gdpr
  // business-setup
  'about': {
    'title': 'About You',
    'subtitle': 'Tell us more about yourself and your business.',
    'business-name': 'Business name',
    'your-name': 'Your name',
    'first-name': 'First name',
    'last-name': 'Last name',
    'phone-number': 'Your phone number',
    'full-name-error': 'Both first and last name must be provided.',
    'phone-error': 'The value must be a valid phone number.',
    'have-referral-code': 'Have a referral code? (optional)',
    'referral-title': 'Have a Referral Code?',
    'referral-content': 'Do you have a referral code from another Booksy professional? If so, enter it here.',
    'referral-code': 'Referral Code (optional)',
    'add-code': 'Add code',
    'referred-by': 'Referred by',
    'stripe-agreement-title': 'I agree to set up a Stripe account to be eligible for payments on Booksy.',
    'stripe-agreement-description': 'I agree to the <a href="https://stripe.com/legal/connect-account" target="_blank">Stripe Connected Account Agreement</a> and acknowledge that my data will be disclosed to Stripe and processed in accordance with the <a href="{privacyLink}" target="_blank">Stripe Privacy Policy</a>. I understand that additional fees may apply when using Booksy Payments.',
  },
  'password-setup': {
    'title': 'Password Setup',
    'subtitle': 'Enter the password for your business profile.',
  },
  'b-listing': {
    'title': 'Is This Your Business?',
    'subtitle': 'We found a business that matches the details you provided. Claim it or continue adding a new business.',
    'create-new': 'Create new',
  },
  'category-selection': {
    'title': 'What’s your business?',
    'text': 'Select the category you feel best represents your business.',
    'other-categories': 'Other categories',
  },
  'confirm-phone': {
    'title': 'Confirm your phone number',
    'text': 'Please enter the {digits}-digit code sent to you at',
    'resend': 'Resend code',
    'verify': 'Verify',
    'error-text': 'Invalid code. Please try again.',
    'code-sent': 'Verification code sent',
  },
  'business-type': {
    'title': 'Select your business type',
    'subtitle': 'Please choose how your business is legally registered.',
    'individual': {
      'title': 'Individual',
      'subtitle': 'I run business under my own name',
    },
    'company': {
      'title': 'Company',
      'subtitle': 'I have an EIN / ITIN number',
    },
  },
  // end business-setup
  // login
  'referral': {
    'title': '"{name}" Has Invited You to Booksy',
    'invited-text': 'I\'ve been using Booksy to run my business and couldn\'t be happier.<br><br>From scheduling appointments to marketing your services, Booksy can help you with everything but sweeping the floor at the end of the day.',
    'invited-text-reward': 'Give Booksy a try. We make appointments better and give you the freedom to manage your business from anywhere.',
    'referral-reward': 'When you subscribe, you get {reward}',
    'get-started': 'Get Started',
  },
  // country selector
  'select-country': {
    'title': 'Select your country',
    'subtitle': 'Please confirm which country your business <br> operates out of.',
    'suggested-subtitle': 'Please confirm which country your business operates out of.',
    'other': 'Other',
    'current': 'Use your current location',
    'select-different': 'Select a different country',
    'not-supported': 'I don\'t see my country',
    'not-listed': {
      'title': 'We\'re Working Our Way There',
      'subtitle': 'We haven\'t quite made it to you yet. Please provide your e-mail below so that we can let you know when Booksy is available in your country. <br><br> Booksy operates in following countries: {countries}',
      'country': 'Your country',
      'email': 'Your e-mail address',
      'btn': 'Notify me',
      'thanks': 'Thanks',
      'thanks-content': 'We\'ve got your information and will be sure to let you know when we\'re headed your way.',
    },
  },
  // end country selector
  'select-language': {
    'title': 'Select your language',
  },
  // select-category
  'business-categories': {
    'title': 'Choose your business category',
    'title-personalized': '{firstName}, tell us about your business',
  },
  'business-main-category': {
    'title': 'What\'s Your Primary Business Category?',
    'subtitle': 'Choose a business category that will help your customers find you when they\'re browsing for services.',
  },
  // location-type
  'location-type': {
    'title': 'Where Do You Work?',
    'title-personalized': 'Where do you work, {firstName}?',
    'subtitle': 'Do your clients come to you, do you go to them, or both?',
    'warning': 'Please select at least one option to continue',

    'no-ttc': 'At my place',
    'no-ttc-desc': 'My clients come to me. I own the place or work in a salon/suite alongside other professionals.',
    'only-ttc': 'At the client\'s location ',
    'only-ttc-desc': 'I\'m on the go. My services are performed at the client\'s location.',
    'hide-address': {
      'label': 'Show address on Booksy profile',
    },
  },
  // location
  'location-search': {
    'title': 'Enter your address',
    'subtitle': 'Where can clients find you?',
    'subtitle-traveling': 'Show local clients that you\'re in their area and are <br> available for booking.',
    'add-location': 'Add Location',
    'cannot-find-address': 'Can\'t find your address?',
    'search-placeholder': 'Search street & number...',
  },
  'location-form': {
    'title-empty-form': 'Type your address',
    'title': 'Confirm your address',
    'subtitle': 'Where can clients find you?',
    'street-number': 'Street Address & Number',
    'apartment': 'Apartment, room or suite number (optional)',
    'city': 'City',
    'zip-code': 'Zipcode',
    'hide-address-title': 'Address visibility',
    'hide-address-subtitle': 'Determines if customers can see your address from your Profile',
    'share-location-title': 'This is a Shared Location',
    'share-location-subtitle': 'Check this box if other business owners work from this location too.',
    'shared-location-name': 'Name of Shared Location',
    'shared-location-room': 'Your room number (optional)',
    'shared-hint-title': 'What is a Shared Location?',
    'shared-hint-desc': 'If you rent a space at a salon, barbershop, spa, or any other type of business where independent specialists provide services to clients, then you can check the Shared Location box. <br><br> When you\'re part of a Shared Location, you will still have your own personal Business Profile with Booksy, but you\'ll also be part of a Profile for your Shared Location. <br><br> Once a Shared Location Profile is created, other specialists who work from that location can join too.',
    'address-modal': {
      'title': 'Your address is missing a street number',
      'description': 'Adding a street number makes it much easier for clients to find your exact location.',
      'add-number': 'Add street number',
      'continue-without': 'Continue without number',
    },
  },
  'join-venue': {
    'title': 'Do You Work Here?',
    'subtitle': 'If so we\'ll link your Booksy profile to this Shared Location. Clients will be able to find you and book you through either profile page. ',
    'suite-number': 'Suite number (if applicable)',
    'modal': {
      'link-profile': 'Link my profile with this location',
      'create-new': 'Create new shared location',
      'subtitle': 'We found an existing shared location that matches the details (name, zip code) you provided. Link your profile with this shared location or continue adding a new one.',
    },
  },
  'map-location': {
    'enter-address': 'Enter Your Address',
    'title': 'Is the pin in the right place?',
    'title-personalized': 'Is the pin in the right place, {firstName}?',
    'empty-title': 'Your Address',
    'empty-subtitle': 'Where can clients find you?',
    'empty': 'Please enter your address to continue',
    'tooltip': 'Move the map to adjust the pin location',
  },
  // traveling-fee
  'traveling-fee': {
    'title': 'What is your travel fee?',
    'subtitle': 'Add your minimum travel fee.',
  },
  'merchant-type-check': {
    title: 'You\'ve Got the Wrong App',
    subtitle: 'It looks like you\'ve landed in the wrong place.',
    'log-into-business': 'Please log in to Booksy Biz Pro to access your calendar, market your services, and manage your day-to-day.',
    'if-trying-downgrade': 'If you\'re trying to downgrade to Booksy Solo please login to Booksy Biz Pro on your tablet or via the web. There you\'ll be able to manage your account settings.',
    'about-solo': 'Booksy Solo is designed specifically for single users who want a simple, mobile-only experience.',
    'log-into-solo': 'Please login to Booksy Solo to manage your business from your mobile device.',
    'if-trying-upgrade': 'If you\'re trying to upgrade to Booksy Biz Pro you can do so on a tablet or via any web browser. Let us know if you\'d like us to send you more information.',
    'about-business': 'With Booksy Biz Pro you\'ll get access to advanced features such as staff management, inventory, and reporting.',
    'email-me-about-solo': 'E-mail me about Booksy Solo',
    'got-it': 'Got It',
  },
  // finish-solo
  'finish-solo': {
    'title': 'Congratulations <br> You\'re All Set',
    'subtitle': 'Welcome to the best tool for managing your Business',
    'description': 'We\'re excited to help you run your business, your way. Spread the word and invite your existing customers to schedule their next appointment using Booksy.',
    'continue': 'Continue',
  },
  // value-proposition
  'value-proposition': {
    'title': 'You\'ve opened a new chapter, {firstName}!',
    'subtitle': 'To help your business thrive, here are a few ways Booksy will do that:',
    'values': {
      'profile': 'Clients book themselves with your Booksy profile',
      'no-shows': 'No-shows are history with automated reminders and custom fees',
      'social-bookings': 'Easy social bookings with social tools to turn followers into clients',
      'payments': 'Flexible modern payments with multiple payment methods, including your phone',
      'marketing': 'Fresh connections with clients using marketing tools for outreach',
    },
  },
  // business-hours
  'business-hours': {
    'title': 'Your Business Hours',
    'description': 'When can clients book with you?',
    'continue': 'Continue',
    'modal-title': 'Copy business hours?',
    'modal-text': 'Would you like to apply the set business hours to other days? If so, select days from the list',
    'break': 'Break',
    'edit-hours-modal-subtitle': 'Set your business hours here. Head to your calendar if you need to adjust hours for a single day.',
    'edit-hours-modal-subtitle-mobile': 'Set your business hours here. Head to Opening Calendar from Settings menu if you need to adjust hours for a single day.',
  },
  // business-services
  'services': {
    'title': 'Start Adding Services',
    'title-import': 'Add your services',
    'your-catalogue-caption': 'Your services list ({current} from {recommended})',
    'subtitle': 'Add at least one service now. Later you can add more, edit details, and group services into categories.',
    'subtitle-import': 'Add at least 3 services now. Later, you can add more, edit details, and group services into categories.',
    'add-service': 'Add service',
    'add-new-service': 'Add new service',
    'delete-service': 'Are you sure you want to delete this service?',
    'at-least-one': 'You must add at least one service to continue.',
    'scan-from-image': 'Scan services from image',
    'add-manually': 'Add services manually',
    'import-services': 'Import services',
    'no-services-added-yet': 'No services added yet',
    'suggest-me-service': 'View more suggestions | View {count} more suggestion | View {count} more suggestions',
    'suggest-me-service-empty': 'View more suggestions',
    'suggestor-landing-page': {
      'title': '{category} services',
      'subtitle': 'Businesses like yours typically add <strong>{count} or more services</strong>.<br>Take a look at our suggestions for inspiration or get started adding your own.',
      'show-suggestions': 'See suggestions',
      'skip': 'Not now',
    },
    'add-more-services-modal': {
      'title': 'Add more services to make your profile more attractive',
      'subtitle': 'Give yourself the best opportunity to attract clients by adding all the services you offer.',
      'add-more': 'Add more services',
      'not-now': 'Not now',
    },
    'suggested-services-modal': {
      'title': 'Suggested services',
      'title-2': 'Select services',
      'subtitle': 'Based on your profile here are some popular services we recommend.',
      'add': 'Add',
      'select': 'Select',
      'selected': 'Selected',
      'add-services': 'Add Services',
      'empty-list-description': 'You have used all of your service recommendations.',
      'popular': {
        'title': 'Top Picks',
        'subtitle': '80% of businesses in your area offer these services',
      },
      'other-hints': {
        'title': 'Other popular services',
      },
    },
    'exit-warning-modal': {
      'title': 'Are you sure you want to exit?',
      'subtitle': 'If you exit now, you will lose all your progress and have to start again.',
      'continue-label': 'Continue editing services',
      'exit-label': 'Exit and start again',
    },
    'form': {
      'title': 'Service Details',
      'title-new': 'Add Service',
      'subtitle': 'Add the basic information for this service now. You\'ll be able to add a description and adjust the advanced settings for this service later on.',
      'name': 'Service Name',
      'duration': 'Service duration',
      'price': 'Price',
      'price-type': 'Price type',
    },
    'prompt': {
      'title': 'You\'re almost set!',
      'subtitle': 'You\'ve added three services so you can complete the setup. You\'ll be able to add more services and modify existing ones later on.',
      'add-more': 'Add more services',
    },
  },
  // activation-delay
  'activation-delay': {
    'title': 'When do you want your profile to go live?',
    'title-personalized': 'When do you want your profile to go live, {firstName}?',
    'subtitle': 'Before you open your books we recommend completing a few more steps, like adding service details and adjusting staff hours. Let us know how much time you\'ll need.',
    'set-live': 'Set my profile live',
    'delay-options': {
      'delay-0': 'Now',
      'delay-1': 'Tomorrow',
      'delay-3': 'In 3 days',
      'delay-5': 'In 5 days',
      'delay-7': 'In 7 days',
    },
  },
  // staffers
  'staffers': {
    'title': 'Add More Staff Members?',
    'subtitle': 'Add basic information about your team. You\'ll be able to complete their profiles, assign services, and adjust working hours later on.',
    'add-staffer': 'Add staff member',
    'me': 'Me',
    'form': {
      'title': 'Add Staff Member',
      'subtitle': 'Include basic staff details. You\'ll be able to complete their full profile later on.',
      'name': 'Name',
      'position': 'Position',
      'cell-phone': 'Phone number',
    },
  },

  invites: {
    'web-view-header': 'Import & Invite clients',
    'web-header': 'Add & Invite clients',
    'skip': 'Skip',
    'start-using-app': 'Start using app',
    'share-profile': {
      'title': 'Almost done, share your profile',
      'start-using-booksy': 'Start using Booksy',
    },
  },

  polls: {
    'max-selections': 'Choose up to {count}',
    'select-which-ones': 'Select which one(s) - choose up to {count}',
  },

  authentication: {
    'login': 'Login',
    'sign-up': 'Sign up',
    'other-sign-up-methods': 'Or sign up with',
    'create-account': 'Create an account',
    'welcome-back': 'Welcome back',
    'login-with-email': 'Log in with email',
    'continue-with-email': 'Continue with email',
    'email-exists': 'Account already exists. Please log in instead.',
    'email-exists-in-customer-app': 'Account already exists. Please log in using your Booksy for Customers details.',
    'extole-banner': {
      'title': '{name} invited you to use Booksy!',
      'description': 'Check it out and get 50% off your first two months.',
      'default-name': 'A friend',
    },
  },

  'google-address': {
    title: 'Is your business visible on Google Maps?',
    description: 'We can find your address to make your setup quicker.',
    'address-select': {
      title: 'Type your address',
      placeholder: 'Street address',
    },

    'select-business-or-address-name': {
      title: 'Where’s your business located?',
      subtitle: 'If you’re on Google, search your business name.',
      placeholder: 'Search address',
    },
    'no-address-found': {
      title: 'Can’t find your business?',
      button: 'Add location',
    },
    'custom-location-form': {
      title: 'Type your address',
      description: 'Where can clients find you?',
    },
    'confirm-business-name-modal': {
      title: 'Confirm your business name',
      description: 'The name you entered during registration is different from your Google Profile name. Please choose which name you\'d like to use',
      'use-google-address': 'Use name from Google',
      'use-booksy-name': 'Keep Booksy name',
    },
    'confirm-address': {
      title: 'Confirm location',
      pin: {
        'info': 'Move the map to adjust the pin',
      },
      'street-number': {
        label: 'Street number',
        subtitle: 'Enter only the number',
        info: 'Number not correct, change it or edit address',
        'error-missing': 'Required',
      },
      'more-details': {
        label: 'Add more details',
        placeholder: 'Apt, suite or unit (optional)',
      },
    },
    'address-lines-warning': 'Search for another location. It needs to be a full address, including the street and city.',
  },
  'portfolio-photos': {
    'title': 'Add photos to showcase your services',
    'subtitle': 'Represent your work with 5-10 photos for your profile.',
    'title-with-photos': 'Showcase your work',
    'subtitle-with-photos': 'Your booking profile is almost ready to share.',
    'skip-button': 'Skip for Now',
    'delete-modal': {
      'title': 'Delete photo?',
      'subtitle': 'Action cannot be undone.',
    },
  },
}
